import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-banner"
}
const _hoisted_2 = { class: "cookie-banner__content" }
const _hoisted_3 = { class: "cookie-banner__main" }
const _hoisted_4 = {
  key: 0,
  class: "cookie-banner__settings"
}
const _hoisted_5 = { class: "cookie-banner__options" }
const _hoisted_6 = { class: "cookie-banner__option" }

import { ref, onMounted, onUnmounted, watch, nextTick } from 'vue';
import analyticsService from '@/services/analytics';
import {ConsentStatus, useCookieConsent} from '@/services/cookieConsent';
import { setCookie } from '@/services/handleCookies';

// Cookie consent management

export default /*@__PURE__*/_defineComponent({
  __name: 'CookieConsentBanner',
  setup(__props) {

const { cookieConsent, updateCookieConsent, COOKIE_CONSENT_KEY } = useCookieConsent();

// Component state
const showBanner = ref(false);
const showSettings = ref(false);
const analyticsEnabled = ref(true);

/**
 * Toggle settings panel
 */
const toggleSettings = (): void => {
  showSettings.value = !showSettings.value;

  // Update body padding after settings panel is toggled
  nextTick(() => {
    updateBodyPadding();
  });
};

/**
 * Save user preferences
 */
const savePreferences = (): void => {
  if (analyticsEnabled.value) {
    // User accepted analytics
    setCookie(COOKIE_CONSENT_KEY, ConsentStatus.ACCEPT);
    analyticsService.enable();
  } else {
    // User declined analytics
    setCookie(COOKIE_CONSENT_KEY, ConsentStatus.DECLINE);
    analyticsService.disable();
  }

  // Update the service state
  updateCookieConsent();

  // Close banner
  showBanner.value = false;
  showSettings.value = false;

  // Remove body padding
  updateBodyPadding();
};

/**
 * Update body padding when banner visibility changes
 */
const updateBodyPadding = (): void => {
  if (showBanner.value) {
    // Add padding to body to prevent banner from hiding content
    const bannerElement = document.querySelector('.cookie-banner') as HTMLElement;
    if (bannerElement) {
      // Wait for DOM update to get accurate height
      setTimeout(() => {
        const bannerHeight = bannerElement.offsetHeight;
        document.body.style.paddingBottom = `${bannerHeight}px`;
      }, 100);
    }
  } else {
    // Remove padding when banner is hidden
    document.body.style.paddingBottom = '0';
  }
};

/**
 * Check and update banner visibility based on consent
 */
const checkBannerVisibility = (): void => {
  // Update consent from cookie
  updateCookieConsent();

  const currentConsent = cookieConsent.value;

  if (currentConsent === ConsentStatus.NOT_SET) {
    // No consent given, show banner
    showBanner.value = true;
    showSettings.value = false;
    analyticsEnabled.value = true;
  } else {
    // Consent already given, hide banner and initialize analytics
    showBanner.value = false;
    showSettings.value = false;

    if (currentConsent === ConsentStatus.ACCEPT) {
      analyticsService.enable();
    } else {
      analyticsService.disable();
    }
  }

  // Update body padding after banner visibility changes
  nextTick(() => {
    updateBodyPadding();
  });
};

/**
 * Initialize component on mount
 */
onMounted(() => {
  // Initial check
  checkBannerVisibility();

  // Listen for cookie changes (e.g., when user clicks "Gérer mes cookies")
  window.addEventListener('cookie-consent-changed', checkBannerVisibility);
});

/**
 * Watch for showBanner changes to update body padding
 */
watch(showBanner, () => {
  nextTick(() => {
    updateBodyPadding();
  });
});

/**
 * Cleanup on unmount
 */
onUnmounted(() => {
  window.removeEventListener('cookie-consent-changed', checkBannerVisibility);
});

return (_ctx: any,_cache: any) => {
  return (showBanner.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "cookie-banner__message" }, " En cliquant sur Accepter, vous autorisez le stockage de témoins pour améliorer la navigation et analyser l’utilisation du site. Vous pouvez Paramétrer vos choix. ", -1)),
            (showSettings.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((analyticsEnabled).value = $event)),
                        class: "cookie-banner__checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, analyticsEnabled.value]
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "cookie-banner__option-label" }, [
                        _createElementVNode("strong", null, "Google Analytics")
                      ], -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "cookie-banner__actions" }, [
              _createElementVNode("button", {
                onClick: savePreferences,
                class: "btn btn-secondary btn-lg cookie-banner__button cookie-banner__button--accept"
              }, " Accepter "),
              _createElementVNode("button", {
                onClick: toggleSettings,
                class: "btn btn-secondary btn-lg cookie-banner__button cookie-banner__button--settings"
              }, " Paramétrer ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})